<template>
  <div v-if="Carga" class="mb-2 card p-2" :class="CardClass">
    <Main-Cargando :cargando="cargando" :MsgError="MsgError">
      <div v-if="LaNotificacion.tipoNotificacion == 'NoDefinida'">
        <h5 class="pull-right p-0">{{ Fecha }}</h5>
        <router-link :to="{}" @click.native="OnMostrarNoDefinida">
          <img
            v-if="Carga.IconoUrl"
            :src="Carga.IconoUrl"
            :class="Carga.Icono"
            class="float-left mr-2"
            width="48"
            style="height: 48px"
          />
          <i v-else :class="Carga.Icono"></i>

          <h5 class="mb-0 pb-0 text-truncate">
            {{ Carga.Titulo }}
          </h5>
          <h5 class="mb-0 pb-0 text-truncate">
            <small>{{ Carga.SubTitulo }}</small>
          </h5>
          <p class="mb-0 pb-0 text-truncate">
            {{ CrearDescripcion(Carga.Aplicacion,Carga.Descripcion) }}
            <!-- {{ Carga.Descripcion }} -->
          </p>
        </router-link>
      </div>
      <div v-else-if="LaNotificacion.tipoNotificacion == 'ChecadaFueraUbicacion'">
        <router-link
          :to="{}"
          class="pull-right p-2"
          data-effect="fadeOut"
          @click.native.stop="OnBorrar()"
        >
          <i class="fa fa-times"></i>
        </router-link>
        <router-link :to="{}" @click.native="OnMostrar">
          <img
            :src="Carga.Colaborador | Foto"
            class="rounded-circle float-left mr-2"
            width="48"
            style="height: 48px"
          />
          <h4 class="mb-0 pb-0 pt-1 text-truncate">
            {{ Carga.Colaborador.Etiqueta }}
          </h4>
          <h5 class="mb-0 pb-0 text-truncate">
            <i :class="Icono"></i>{{ Etiqueta }} {{ Carga.Colaborador.LinkID }}
          </h5>
        </router-link>
      </div>
      <div v-else-if="Carga.Colaborador">
        <router-link :to="{}" @click.native="OnMostrar">
          <img
            :src="Carga.Colaborador | Foto"
            class="rounded-circle float-left mr-2"
            width="48"
            style="height: 48px"
          />
          <h4 class="mb-0 pb-0 pt-1 text-truncate">
            {{ Carga.Colaborador.Etiqueta }}
          </h4>
          <h5 class="mb-0 pb-0 text-truncate">
            <i :class="Icono"></i>{{ Etiqueta }} {{ Carga.Colaborador.LinkID }}
          </h5>
        </router-link>
      </div>
      <div v-else>
        <router-link
          :to="{}"
          class="pull-right p-2"
          data-effect="fadeOut"
          @click.native.stop="OnBorrar()"
        >
          <i class="fa fa-times"></i>
        </router-link>
        <router-link
          class=""
          :to="{}"
          data-effect="fadeOut"
          @click.native="OnMostrar"
        >
          <img
            v-if="Carga.Respuesta && Carga.Respuesta.Colaborador"
            :src="Carga.Respuesta.Colaborador | Foto"
            class="rounded-circle float-left mr-2"
            width="48"
            style="height: 48px"
          />
          <h4
            v-if="Carga.Respuesta && Carga.Respuesta.Colaborador"
            class="mb-0 pb-0 pt-1 text-truncate"
          >
            {{ Carga.Respuesta.Colaborador.Etiqueta }}
          </h4>
          <h4 class="mb-0 pb-0 text-truncate">
            <i :class="Icono"></i> {{ Etiqueta }}
          </h4>
          <h5 class="mb-0 pb-0 text-truncate">{{ Datos }}</h5>
        </router-link>
      </div>
    </Main-Cargando>

    <NotificacionModal
      v-if="Modal"
      :Mostrar.sync="Modal"
      :MsgError="MsgError"
      v-model="LaNotificacion"
      @autorizar="OnAutorizar"
      :cargando="cargando"
      @Borrar="OnBorrar()"
    ></NotificacionModal>
  </div>
</template>

<script>
import moment from "moment";
import { formatDateToCustomString } from "@/api-services/LiFecha";
//var moment = require('moment');
moment.locale("es-mx");
import NotificacionModal from "./Notificacion.modal.vue";
import Notificaciones from "@/api-services/notificaciones.service";
import Colaboradores from "@/api-services/colaboradores.service";
export default {
  name: "LayOuts-Notificacion",
  props: {
    value: Object,
  },
  components: {
    NotificacionModal,
  },
  data() {
    return {
      LaNotificacion: null,
      Carga: null,
      Modal: false,
      cargando: false,
      Erroneo: "",
      Comentarios: "",
      MsgError: "",
    };
  },
  watch: {
    Modal(Modal) {
      // return;

      if (!Modal) {
        this.$nextTick(() => {
          this.$emit("actualizar", this.value);
          this.$emit('abrir'); // Cierra el panel móvil al cerrar el modal
        });
      }
    },
  },
  computed: {
    Fecha() {
      return formatDateToCustomString(this.LaNotificacion.creado);
    },
    CardClass() {
      if (
        this.Carga.Respuesta != undefined &&
        this.Carga.Respuesta.Aceptada != undefined
      ) {
        if (this.Carga.Respuesta.Aceptada) return "bg-success dropdown-menu-ancho";
        else return "bg-danger dropdown-menu-ancho";
      }
      return "dropdown-menu-ancho";
    },
    EsperaRespuesta() {
      return Notificaciones.EsperaRespuesta(
        this.LaNotificacion.tipoNotificacion
      );
    },
    TituloDias() {
      if (this.Carga && this.Carga.Dias) {
        if (this.Carga.Dias.length > 1) return "Para los siguientes días:";
        return "Para el siguiente día:";
      }
      return "";
    },
    Icono() {
      return Notificaciones.Icono(this.LaNotificacion.tipoNotificacion);

      //fa fa-times
    },
    Etiqueta() {
      return Notificaciones.Etiqueta(this.LaNotificacion.tipoNotificacion);
    },
    Datos() {
      return Notificaciones.Datos(this.Carga);
    },
    Titulo() {
      return Notificaciones.Titulo(this.LaNotificacion.tipoNotificacion);
    },
  },
  mounted() {
    this.LaNotificacion = Object.assign({}, this.value);
    this.Carga = JSON.parse(this.value.carga);
  },
  filters: {
    Foto(Registro) {
      return Colaboradores.FotoURL(Registro);
    },
  },
  methods: {
    OnMostrar() {
      if (Notificaciones.Redirigir(this, this.LaNotificacion)) {
        //this.$router.push(`/empleado/acceso-nuevo?n=${this.LaNotificacion.id}`);
        // El watcher de $route en HomeNavbar cierra el menú móvil automáticamente
        return;
      }
      this.$emit('abrir');
      this.Modal = true;
    },
    FDia(Dia) {
      return moment(Dia).format("dddd D/MMMM/YY");
    },

    OnAutorizar(Parametros) {
      if (Parametros == undefined)
        Parametros = { Comentarios: "", Autorizar: false };
      Notificaciones.put(
        this,
        this.LaNotificacion.id,
        {
          respuesta: Parametros.Comentarios,
          aceptada: Parametros.Autorizar,
        },
        (response) => {
          /*  if (response.data.borrado) {
              for (var i = 0; i < Notificaciones.Notificaciones.length; i++) {
                console.debug(Notificaciones.Notificaciones[i].id);
                if (Notificaciones.Notificaciones[i].id == response.data.id) {

                  Notificaciones.Notificaciones.borrado = true;
                  i--;
                }
              }
              }*/
          this.Modal = false;
        },
        (MsgError, error) => {
          if (error.response == undefined) {
            MsgError = "Intente nuevamente en un par de minutos";
          } else
            switch (error.response.status) {
              case 404:
                MsgError = "No tiene permisos de modificación";
                break;
            }
          return MsgError;
        }
      );
    },
    OnBorrar() {
      Notificaciones.delete(this, this.LaNotificacion.id, (response) => {
        this.$emit("Actualizar", this);
      });
    },
    OnMostrarNoDefinida() {
      this.$emit('abrir');
      //La NOM-035 se marca como leída hasta que el colaborador acepta la invitación,
      //no por abrirla: desde ahí puede posponerla con "Recordarme más tarde" y el aviso
      //debe seguir aquí. Las demás aplicaciones que usan este tipo genérico, eTickets
      //entre ellas, sí esperan que el clic las descarte.
      if (this.Carga.Aplicacion != "NOM-035")
        this.OnBorrar();
      //* Guardar en el back que ya se abrio o eliminarla
      if (this.Carga.URL)
        window.open(this.ObtenLigaAmbiente(this.Carga.URL), "_blank");
    },

    /**
     * Devuelve la liga de la notificación apuntando al ambiente donde se está
     * trabajando: local abre local, beta abre beta y producción abre producción.
     *
     * La liga se guarda absoluta al crear la campaña, con la propiedad URLeClockGo
     * de la suscripción, que vive en la BD General que comparten todos los ambientes
     * y por omisión es https://go.eClock.com.mx. Por eso desde local o beta la
     * notificación brincaba a producción: no es un ambiente distinto para el back,
     * es el dominio del cliente. Como ese dato no puede distinguir ambientes, se
     * corrige aquí, al abrir.
     *
     * Sólo aplica a la NOM-035, que es la que apunta a este mismo front. Las otras
     * aplicaciones que usan el tipo genérico —eTickets entre ellas— mandan a sus
     * propios sitios y ahí reescribir el dominio las rompería.
     */
    ObtenLigaAmbiente(Liga) {
      if (!Liga || this.Carga.Aplicacion != "NOM-035") return Liga;
      //Las ligas de referencia son /r/{linkID}; si no tiene esa forma se deja igual.
      var Coincide = /\/r\/([^/?#]+)/i.exec(Liga);
      if (!Coincide) return Liga;
      return this.$router.resolve({ path: `/r/${Coincide[1]}` }).href;
    },

    CrearDescripcion(Tipo,Descripcion){
      if (Tipo != undefined && Tipo =="eTickets") {
        if (Descripcion.includes("/")) {
          let nuevaDescp =Descripcion.split("/")
          return  nuevaDescp[nuevaDescp.length -1]
        }
      }
      return Descripcion
    },
  },
};
</script>

<style scoped></style>

<style>
@media (min-width: 768px) {
  .dropdown-menu-ancho {
    width: 500px !important;
  }
}

@media (max-width: 767.98px) {
  .dropdown-menu-ancho {
    width: 100% !important;
  }
}
</style>
